import { useState } from "react";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/cn";

interface Props {
  data: unknown;
  className?: string;
  /** Collapse nested structures deeper than this level (reserved for future use). */
  collapseDepth?: number;
}

export function JsonViewer({ data, className, collapseDepth: _collapseDepth = 3 }: Props) {
  const [expanded, setExpanded] = useState(false);
  const text = JSON.stringify(data, null, 2);
  const isLong = text.length > 500;
  const shown = !expanded && isLong ? text.slice(0, 500) + "\n…" : text;

  return (
    <div className={cn("relative rounded border bg-muted", className)}>
      <pre className="text-xs p-3 overflow-auto max-h-96 whitespace-pre-wrap break-words">
        {shown}
      </pre>
      {isLong && (
        <Button
          variant="ghost"
          size="sm"
          className="absolute bottom-1 right-1"
          onClick={() => setExpanded((v) => !v)}
        >
          {expanded ? "Collapse" : "Expand"}
        </Button>
      )}
    </div>
  );
}
